import { Link } from "react-router-dom";
import { Stack, Typography } from "@mui/material";
import { Button } from "../../Buttons";

export default function Menu({ title, options, isActive }) {
    return (
        <Stack sx={{ width: "100%", gap: 1.5 }}>
            <Typography sx={{ color: "var(--text-secondary)" }}>
                {title}
            </Typography>

            <Stack sx={{ gap: "4px" }}>
                {options.map(({ label, icon, path }) => (
                    <Link
                        key={label}
                        to={path}
                        sx={{ textDecoration: "none", width: "100%" }}
                    >
                        <Button
                            startIcon={icon}
                            variant={isActive(path) ? "contained" : "text"}
                            color={isActive(path) ? "primary" : "default"}
                            sx={{
                                justifyContent: "flex-start",
                                gap: "12px",
                                width: "100%",
                            }}
                        >
                            {label}
                        </Button>
                    </Link>
                ))}
            </Stack>
        </Stack>
    );
}
